import { Observable, of } from "rxjs";

import da from "../../assets/locale-da-dk.json";
import en from "../../assets/locale-en-us.json";
import { Language } from "../models/language";

export type TranslationTexts = typeof da | typeof en;

export class LanguageService {
  #translations: TranslationTexts;
  #locale: Language;

  constructor(languageCode: Language) {
    this.#locale = languageCode;
    const locales = {
      "da-DK": da,
      "en-US": en,
    };
    this.#translations = locales[languageCode];
  }

  getTranslations = () => this.#translations;
  getLanguage = () => this.#locale;
}
